module.exports = __webpack_public_path__ + "static/img/Office-excel-xls-icon.be87a644.png";